module.exports = __webpack_public_path__ + "img/estante-virtual-thumb.314e07b2.jpg";